/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

export type CompareWithFn<T> = (value1: T, value2: T) => boolean;

export const CompareByRef: CompareWithFn<any> = (v1, v2) => v1 === v2;

export const CompareById: CompareWithFn<{ id: number }> = ({id: id1}, {id: id2}) => id1 === id2;
